export class ScheduledSectionStatus {
  static UNSCHEDULED = '';
  static REGISTERED = 'REGISTERED';
  static SECTION_PICKED = 'SECTION_PICKED';
  static PENDING = 'PENDING';
  static FAILED = 'FAILED';
  static WAITLISTED = 'WAITLISTED';
  static WITHDRAWN = 'WITHDRAWN';
  static WAITLISTFAILED = 'WAITLISTFAILED';
  static WAITLISTDROPFAILED = 'WAITLISTDROPFAILED';
  static WAITLISTEDCANADD = 'WAITLISTEDCANADD';
  static IN_PROGRESS = 'IN_PROGRESS';
  static COMPLETED = 'COMPLETED';
  static CONFLICTING = 'CONFLICTING';
  static DROPFAILED = 'DROPFAILED';
  static NOT_REGISTERED = 'NOT_REGISTERED';
  static SWAP_FROM = 'SWAP_FROM';
  static SWAP_TO = 'SWAP_TO';
  static getRegisteredSectionStatuses() {
    return [ScheduledSectionStatus.REGISTERED, ScheduledSectionStatus.IN_PROGRESS, ScheduledSectionStatus.COMPLETED];
  }
  static getScheduledSectionStatuses() {
    // during the time between a register POST and a pusher response
    // a section status is PENDING, if it fails it FAILED
    // these 3 statuses qualify as `scheduled` in the scheduled sections bucket
    return [ScheduledSectionStatus.SECTION_PICKED, ScheduledSectionStatus.PENDING];
  }
  static getWaitlistedSectionStatuses() {
    return [ScheduledSectionStatus.WAITLISTED];
  }
  static getFailedWaitlistDropSectionStatuses() {
    return [];
  }
  static getFailedStatusesForUnSchedule() {
    return [ScheduledSectionStatus.UNSCHEDULED];
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/types/scheduled_section_status_enum.ts